import { object, ObjectSchema, string } from 'yup';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  enable: string().label('ステータス').oneOf(['enable', 'disable']).required(),
});
